import React from "react";
import { Link } from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import { navigationItems } from "./navigationItems";
import HomeSectionLink from "./HomeSectionLink";

const publicPath = (path) => process.env.PUBLIC_URL + path;

const DesktopNavigation = () => (
  <ul className="nav menu-nav">
    {navigationItems.map((item) => (
      <li
        className={`nav-item${item.children ? " dropdown" : ""}${
          item.path === "/" ? " active" : ""
        }`}
        key={item.label}
      >
        {item.sectionId ? (
          <HomeSectionLink sectionId={item.sectionId} className="nav-link">
            {item.label}
          </HomeSectionLink>
        ) : (
          <Link
            className={`nav-link${item.children ? " dropdown-toggle" : ""}`}
            to={publicPath(item.path || "/")}
            {...(item.children ? { "data-toggle": "dropdown" } : {})}
          >
            {item.label}
            {item.children && <i className="las la-angle-down"></i>}
          </Link>
        )}

        {item.children && (
          <ul className="dropdown list-unstyled">
            {item.children.map((child) => (
              <li className="nav-item" key={`${item.label}-${child.label}`}>
                <Link className="nav-link" to={publicPath(child.path)}>
                  {child.countryCode && (
                    <ReactCountryFlag
                      countryCode={child.countryCode}
                      svg
                      style={{ marginRight: "8px" }}
                    />
                  )}
                  {child.label}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </li>
    ))}
  </ul>
);

export default DesktopNavigation;
